const
    blankPixel = () => (
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'),

    blankImage = (width, height) => {
        const
            canvas = (
                Object.assign(
                    document.createElement('canvas'),
                    {width, height})),
            context = canvas.getContext('2d');

        context.fillStyle = 'rgba(0,0,0,0)';
        context.fillRect(0, 0, width, height);
        return canvas.toDataURL();
    };

export {
    blankPixel,
    blankImage
};
